import AttendanceAdapter from './base';

export default class Analysis extends AttendanceAdapter {
  modelNamePlural = 'analyses';
}
